import ActionOrEventInfo from './ActionOrEventInfo';

export default ActionOrEventInfo;
